/* Collapses a long collection description behind a Read more button.

   The button ships hidden and is only revealed once we have measured that the
   text is actually taller than the fold. A short description therefore never
   gets a pointless "Read more" that expands nothing.

   Collapsing is applied here rather than in CSS so that with scripts off the
   full text is visible — search engines and readers both get everything. */
(function () {
  'use strict';

  function setup(body) {
    if (body._fxDone) return;
    var max = parseInt(body.getAttribute('data-fx-max'), 10);
    if (!max) return;
    var btn = body.parentNode.querySelector('[data-fx-collapse-btn]');
    if (!btn) return;
    body._fxDone = true;

    if (body.scrollHeight <= max + 24) return; // short enough already

    var collapsed = true;
    var apply = function () {
      if (collapsed) {
        body.setAttribute('data-fx-collapsed', '');
        body.style.maxHeight = max + 'px';
        btn.textContent = btn.getAttribute('data-more');
        btn.setAttribute('aria-expanded', 'false');
      } else {
        body.removeAttribute('data-fx-collapsed');
        body.style.maxHeight = '';
        btn.textContent = btn.getAttribute('data-less');
        btn.setAttribute('aria-expanded', 'true');
      }
    };

    btn.hidden = false;
    apply();
    btn.addEventListener('click', function () { collapsed = !collapsed; apply(); });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-fx-collapse]').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
